// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__Mxs2R","form":"styles_form__3kNHA"};